/* eslint-disable react/require-default-props */
import React from 'react';
import './ActionButtons.scss';
function ActionButtons({ children }) {
    return React.createElement("div", { className: "action-buttons" }, children);
}
export default ActionButtons;
